var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: "0.4px",
    opacity: 0.3,
    d: "M32,57.14A25.15,25.15,0,0,1,11.28,17.75,2,2,0,0,1,14.58,20a21.08,21.08,0,1,0,7.83-6.87A2,2,0,1,1,20.6,9.59,24.88,24.88,0,0,1,32,6.86a25.14,25.14,0,0,1,0,50.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: "0.4px",
    opacity: 0.3,
    d: "M25.5,41.61a2,2,0,0,1-2-2V24.39a2,2,0,0,1,4,0V39.61A2,2,0,0,1,25.5,41.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    steoke: "white",
    strokeWidth: "0.4px",
    opacity: 0.3,
    d: "M38.5,41.61a2,2,0,0,1-2-2V24.39a2,2,0,0,1,4,0V39.61A2,2,0,0,1,38.5,41.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewPause);
export default __webpack_public_path__ + "static/media/preview-pause.d297f7e3e01a6cc1425c7807556dcce7.svg";
export { ForwardRef as ReactComponent };